import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#0D47A1',
        },
        secondary: {
            main: '#ebf0f7',
        },
        background: {
            default: '#0D47A1',
        },
        text: {
            primary: '#000000',
        },
        white: {
            '50': '#ffffff',
            '100': '#f7f7f7',
            '200': '#efefef',
            '300': '#e7e7e7',
            '400': '#dfdfdf',
            '500': '#d7d7d7',
            '600': '#cfcfcf',
            '700': '#c7c7c7',
            '800': '#bfbfbf',
            '900': '#b7b7b7',
        },
        black: {
            '50': '#000000',
            '100': '#111111',
            '200': '#222222',
            '300': '#333333',
            '400': '#444444',
            '500': '#555555',
            '600': '#666666',
            '700': '#777777',
            '800': '#888888',
            '900': '#999999',
        },
        red: {
            '50': '#FFEBEE',
            '100': '#FFCDD2',
            '200': '#EF9A9A',
            '300': '#E57373',
            '400': '#EF5350',
            '500': '#F44336',
            '600': '#E53935',
            '700': '#D32F2F',
            '800': '#C62828',
            '900': '#B71C1C',
        },
        blue: {
            '50': '#E3F2FD',
            '100': '#BBDEFB',
            '200': '#90CAF9',
            '300': '#64B5F6',
            '400': '#42A5F5',
            '500': '#2196F3',
            '600': '#1E88E5',
            '700': '#1976D2',
            '800': '#1565C0',
            '900': '#0D47A1',
        },
        green: {
            '50': '#e8f5e9',
            '100': '#c8e6c9',
            '200': '#a5d6a7',
            '300': '#81c784',
            '400': '#66bb6a',
            '500': '#4caf50',
            '600': '#43a047',
            '700': '#388e3c',
            '800': '#2e7d32',
            '900': '#1b5e20',
        },
        aqua: {
            '50': '#E6FFFA',
            '100': '#C0FFF2',
            '200': '#99FFEA',
            '300': '#73FFE2',
            '400': '#4DFFDA',
            '500': '#7FFFD4',
            '600': '#4DEBC6',
            '700': '#1BD7B8',
            '800': '#00C3AA',
            '900': '#009B8C',
        },
        purple: {
            '50': '#F2E6F2',
            '100': '#E0B3E0',
            '200': '#CF80CF',
            '300': '#BF4DBF',
            '400': '#AF1AAF',
            '500': '#800080',
            '600': '#660066',
            '700': '#4D004D',
            '800': '#330033',
            '900': '#1A001A',
        },
        yellow: {
            '50': '#FFFFE6',
            '100': '#FFFFCC',
            '200': '#FFFF99',
            '300': '#FFFF66',
            '400': '#FFFF33',
            '500': '#FFFF00',
            '600': '#E6E600',
            '700': '#CCCC00',
            '800': '#B3B300',
            '900': '#808000',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: '8px',
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                },
            },
        },
    },
    typography: {
        fontFamily: [
          'Plus Jakarta Sans',
          '-apple-system',
          'BlinkMacSystemFont',
          'sans-serif',
        ].join(','),
        h1: {
          fontFamily: 'Plus Jakarta Sans',
          fontWeight: 700,
        },
        h2: {
          fontFamily: 'Plus Jakarta Sans',
          fontWeight: 700,
        },
        h5: {
          fontFamily: 'Plus Jakarta Sans',
          fontWeight: 400,
        },
        h6: {
          fontFamily: 'Plus Jakarta Sans',
          fontWeight: 600,
        },
        button: {
          fontFamily: 'Plus Jakarta Sans',
          fontWeight: 600,
          textTransform: 'none',
        },
      },
    // components: {
    //     MuiCssBaseline: {
    //         styleOverrides: {
    //             body: {
    //                 fontFamily: 'Inter, sans-serif',
    //             },
    //         },
    //     },
    // },
});

export default theme;